module.exports = __webpack_public_path__ + "static/media/LowerColon.cc554261.svg";